<template>
  <v-card>
    <v-card-title>Skills</v-card-title>
    <v-card class="d-flex flex-wrap pa-2 pt-0 ml-1 pb-4" elevation="0">
      <v-card elevation="0" color="blue" class="d-inline-flex mt-3 mr-3" v-for="skill in skills" :key="skill.id">
        <v-card-text class="pa-2 white--text">{{ skill.name }}</v-card-text>
      </v-card>
    </v-card>
    <!-- <v-row v-for="skill in skills" :key="skill.id">
      <v-col cols="6" class="py-2">
        <v-card-text class="pt-0 pb-0 font-weight-bold text-subtitle-1">{{ skill.name }}</v-card-text>
      </v-col>
      <v-col class="pt-2 pr-8 pb-0 d-flex justify-end align-start" cols="6">
        <v-icon color="#5cb85c" v-for="i in skill.star" :key="i">mdi-star</v-icon>
        <v-icon color="#5cb85c" v-for="i in 5-skill.star" :key="i">mdi-star-outline</v-icon>
      </v-col>
    </v-row> -->
  </v-card>
</template>

<script>
export default {
  name: 'Skills',
  data(){
    return {
      skills: [
        {name: 'Python', star: 5},
        {name: 'JavaScript', star: 3},
        {name: 'Julia', star: 2},
        {name: 'Django', star: 4},
        {name: 'Scikit-Learn', star: 4},
        {name: 'FastAPI', star: 4},
        {name: 'Selenium', star: 4},
        {name: 'VueJS', star: 4},
        {name: 'Apache Spark', star: 3},
        {name: 'Apache Arrow', star: 3},
        {name: 'ElasticSearch', star: 4},
        {name: 'PostgreSQL', star: 4},
        {name: 'Git', star: 4},
        {name: 'AWS', star: 3},
        {name: 'Linux', star: 3},
        {name: 'Docker', star: 3},
        {name: 'Scrum/Agile', star: 3},
      ]
    }
  }
}
</script>

<style>

</style>